export type ProductClickAction = 'none' | 'switch' | 'confirm';

/**
 * Decide what a click on a product card in the sidebar does. On the design
 * step the big canvas is the master design; focusing a product that carries
 * its own placement must not silently drop that placement, so we ask first.
 */
export function resolveProductClickAction(input: {
  isFocused: boolean;
  currentStep: string;
  hasOverrides: boolean;
}): ProductClickAction {
  if (input.isFocused) return 'none';
  if (input.currentStep === 'design' && input.hasOverrides) return 'confirm';
  return 'switch';
}
